import React, { useState, useEffect } from "react";
// import { Navigation } from "./navigation";
// import { Footer } from "./footer";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // WhatsApp Message
  const whatsappMessage = `
Name: ${name}

Email: ${email}

Message: ${message}
`;

  const whatsappLink = `https://wa.me/919289492133?text=${encodeURIComponent(
    whatsappMessage,
  )}`;

  return (
    <div>
      {/* <Navigation /> */}

      <div id="contact">
        <div className="container">
          {/* Contact Form */}
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>

                <p>
                  Please fill out the form below and send your message directly
                  on WhatsApp.
                </p>
              </div>

              <form>
                <div className="row">
                  {/* Name */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Message */}
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                {/* WhatsApp Button */}
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-custom btn-lg"
                  onClick={() => {
                    setTimeout(() => {
                      setState(initialState);
                    }, 500);
                  }}
                >
                  <i className="fa fa-whatsapp"></i> Send Message
                </a>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>

              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                635 Gautam Puri Phase I Badarpur New Delhi 110044
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>
                +91-9289492133
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>
                d.aenterprises635@gmail.com
              </p>
            </div>
          </div>

          {/* Google Map */}
          <div style={{ marginTop: "40px" }}>
            {/* <iframe
              title="Google Map Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.8571852584137!2d77.29724818295293!3d28.51394422689437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce75da7945553%3A0x1a9d4d4c36917529!2sGautam%20puri!5e0!3m2!1sen!2sus!4v1775632389984!5m2!1sen!2sus"
              width="100%"
              height="450"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe> */}

            <iframe
             title="Google Map Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.8332017243083!2d77.3035112!3d28.514665700000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce771fdc41679%3A0xfa6bfc00fe357547!2sD.A%20Enterprises!5e0!3m2!1sen!2sin!4v1778228666142!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
};
